import type { Transport, TransportPayload } from "@ots-frontend/ots-data";

/** What to set on every chosen transport; a field left out stays as each transport has it. */
export type BulkTransportChanges = {
  personId?: string;
  vehicleId?: string;
  trailerId?: string;
  /** The freight type, which transports call their water type. */
  waterTypeId?: string;
  serviceTypeId?: string;
};

export type BulkTransportSide = "both" | "pickup" | "delivery";

/** A ticket's or lone transport's two sides, as far as it has them. */
export type BulkTransportTarget = { pickup?: Transport; delivery?: Transport };

export const hasBulkChanges = (changes: BulkTransportChanges) => Object.values(changes).some((value) => value != null && value !== "");

/**
 * The saves for a bulk edit: each chosen side of each target, whole as the ticket form saves it (less its comments
 * and gauges), with the changes over it. A transport on two targets is saved once.
 */
export const bulkTransportSaves = (targets: BulkTransportTarget[], changes: BulkTransportChanges, side: BulkTransportSide): TransportPayload[] => {
  const set = Object.fromEntries(Object.entries(changes).filter(([, value]) => value != null && value !== ""));
  const transports = targets.flatMap((target) => [
    side !== "delivery" ? target.pickup : undefined,
    side !== "pickup" ? target.delivery : undefined,
  ]).filter((transport): transport is Transport => !!transport);
  return [...new Map(transports.map((transport) => [transport.id, transport])).values()].map((transport) => ({
    ...Object.fromEntries(Object.entries(transport).filter(([key]) => key !== "messages" && key !== "gauges")),
    ...set,
  }));
};
